import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { StudentDetailsComp } from './studentdetails';
import { AddNewUser, GetProcessList, GetUserDetails, UpdateUserDetails } from '../../models/process';
import { pnkstore } from '../../stores/pnk-store';
import { useUserStore } from '../../stores/user-store';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { GetAllProject, GetAreasList, GetCitiesList, GetDistrictList, GetStatesList } from '../../models/project';
import { AddNewInstitute, AddNewLead, AddNewStudent, GetAllInstitutes, GetAllLeads, GetStudentList, UpdateInstitute, UpdateInstituteDesc, UpdateLead, UpdateLeadDesc, UpdateStudent, UpdateStudentDesc } from '../../models/leads';
import { GetProfileList } from '../../models/profile';
import { GetUserList } from '../../models/user';

export const StudentDetails = () => {
    const userData = useUserStore;
    const [tabName, setTabName] = useState('Customer Details');
    const [LeadFormData, setLeadFormData] = useState({});

    const [getProfileList, setGetProfileList] = useState(true);
    const [profileListData, setProfileListData] = useState([]);
    const [getUserList, setGetUserList] = useState(true);
    const [userListData, setUserListData] = useState([]);

    const [getLeadDetails, setGetLeadDetails] = useState(false);

    const [instituteSearchObj, setInstituteSearchObj] = useState({});
    const [getInstituteList, setGetInstituteList] = useState(true);
    const [instituteListData, setInstituteListData] = useState([]);

    const [leadDetails, setLeadDetails] = useState([]);
    const [leadSearchObj, setLeadSearchObj] = useState({});

    const [setNo, setSetNo] = useState(1);
    const [perSet, setPerSet] = useState(20);

    const [openDescriptionBox, setOpenDescriptionBox] = useState(false);
    const [openProjectDetailsBox, setOpenProjectDetailsBox] = useState(false);
    const [mode, setMode] = useState('add');
    const [addLead, setAddLead] = useState(false);
    const [editLead, setEditLead] = useState(false);
    const [updateLeadDesc, setUpdateLeadDesc] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertMsg, setAlertMsg] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    const state = {
        userData: userData.getState(),
        tabName: tabName,
        mode: mode,
        addUser: addLead,
        editUser: editLead,
        openDescriptionBox: openDescriptionBox,
        openProjectDetailsBox: openProjectDetailsBox,
        leadDetails: leadDetails,

        profileListData: profileListData,
        userListData: userListData,
        instituteListData: instituteListData,

        showAlert: showAlert,
        alertMsg: alertMsg,
        alertType: alertType,

    }

    useEffect(() => {
        let student_id = params.student_id;
        if (student_id !== undefined && student_id !== null && student_id !== '' && student_id !== 'new') {
            setMode('edit');
            setLeadSearchObj({
                'txtStudentId': student_id
            })
            setGetLeadDetails(true);
            setLeadFormData((prev) => ({ ...prev, ['txtStudentId']: student_id }));
        }
        else {

        }
    }, []);


    const HandleCheckBox = (e, name) => {
        if (LeadFormData[name] === true) {
            setLeadFormData((prev) => ({ ...prev, [name]: false }));
        }
        else {
            setLeadFormData((prev) => ({ ...prev, [name]: true }));
        }
    }

    const HandleInputs = (e, name) => {
        let value = '';

        if (name === 'txtInterviewDate' || name === 'txtJoiningDate') {
            value = e.$d;
            value = new Date(new Date(value).getTime() - (new Date(value).getTimezoneOffset() * 60000)).toISOString().substr(0, 10).replace('T', ' ')
        }
        else {
            value = e.target.value
        }

        if (name === 'txtKidsCount' || name === 'txtContactNumber' || name === 'txtSalaryOffered' || name === 'txtNursesB1' || name === 'txtNursesB2' || name === 'txtWinRatePercentage' || name === 'txtTotalHired' || name === 'txtTotalCvsShared' || name === 'txtTalentPoolSizeMonthly' || name === 'txtDealValuePerMonth') {
            value = value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');
            setAddLead(false);
        }


        if (name === 'txtDOB') {
            let age = '';
            if (value) {
                const dob = new Date(value);
                const today = new Date();
                age = today.getFullYear() - dob.getFullYear();
                const monthDiff = today.getMonth() - dob.getMonth();
                if (
                    monthDiff < 0 ||
                    (
                        monthDiff === 0 &&
                        today.getDate() < dob.getDate()
                    )
                ) {
                    age--;
                }
            }
            setLeadFormData((prev) => ({
                ...prev,
                txtAge: age
            }));
        }

        if (name === 'txtStudentReferredBy') {

            const selectedInstitute =
                instituteListData.find(
                    (item) =>
                        item.institute_name === value
                );


                console.log(selectedInstitute);
                console.log(selectedInstitute);
                console.log(selectedInstitute);

            setLeadFormData((prev) => ({
                ...prev,
                txtStudentReferredBy: selectedInstitute?.institute_name,

                txtUPRNPOC:
                    selectedInstitute?.institute_uprn_poc || '',

                txtB2BPartnerName:
                    selectedInstitute?.institute_name || '',
                txtInstituteId:
                    selectedInstitute?._id || ''
            }));

          

            return;
        }



        if (name === 'ddlLeadOwner') {
            PopulatePocDetails(value);
        }

        setLeadFormData((prev) => ({ ...prev, [name]: value }));


    }

    const PopulatePocDetails = (val) => {
        let pocData = userListData.find(
            (item) => item.user_name === val
        );
        if (pocData) {
            setLeadFormData((prev) => ({
                ...prev,
                txtInstituteUprnPoc: pocData.user_name || '',
            }));
        }
    };

    const SaveOrUpdateLead = () => {

        let emailRegex =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        let mobileRegex = /^[0-9]{10}$/;

        /* =========================
           PERSONAL INFORMATION
        ========================== */

        if (
            !LeadFormData.txtFirstName ||
            LeadFormData.txtFirstName.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtFirstNameErr: 'Please Enter First Name'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtFirstNameErr: ''
            }));
        }

        // if (
        //     !LeadFormData.txtLastName ||
        //     LeadFormData.txtLastName.trim() === ''
        // ) {
        //     setLeadFormData((prev) => ({
        //         ...prev,
        //         txtLastNameErr: 'Please Enter Last Name'
        //     }));
        //     return false;
        // } else {
        //     setLeadFormData((prev) => ({
        //         ...prev,
        //         txtLastNameErr: ''
        //     }));
        // }

        if (
            !LeadFormData.txtDOB ||
            LeadFormData.txtDOB.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtDOBErr: 'Please Select Date Of Birth'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtDOBErr: ''
            }));
        }

        if (
            !LeadFormData.ddlQualification ||
            LeadFormData.ddlQualification.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                ddlQualificationErr: 'Please Select Qualification'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                ddlQualificationErr: ''
            }));
        }

        if (
            !LeadFormData.ddlMaritalStatus ||
            LeadFormData.ddlMaritalStatus.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                ddlMaritalStatusErr: 'Please Select Marital Status'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                ddlMaritalStatusErr: ''
            }));
        }

        if (
            LeadFormData.ddlMaritalStatus === 'Married' &&
            (
                LeadFormData.txtKidsCount === '' ||
                LeadFormData.txtKidsCount === undefined ||
                LeadFormData.txtKidsCount === null
            )
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtKidsCountErr: 'Please Enter Kids Count'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtKidsCountErr: ''
            }));
        }

        /* =========================
           CONTACT INFORMATION
        ========================== */

        if (
            !LeadFormData.txtContactNumber ||
            LeadFormData.txtContactNumber.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtContactNumberErr: 'Please Enter Contact Number'
            }));
            return false;
        }
        else if (
            !mobileRegex.test(
                LeadFormData.txtContactNumber.trim()
            )
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtContactNumberErr: 'Please Enter Valid 10 Digit Number'
            }));
            return false;
        }
        else {
            setLeadFormData((prev) => ({
                ...prev,
                txtContactNumberErr: ''
            }));
        }

        // if (
        //     LeadFormData.txtWhatsappNumber &&
        //     !mobileRegex.test(
        //         LeadFormData.txtWhatsappNumber.trim()
        //     )
        // ) {
        //     setLeadFormData((prev) => ({
        //         ...prev,
        //         txtWhatsappNumberErr:
        //             'Please Enter Valid Whatsapp Number'
        //     }));
        //     return false;
        // } else {
        //     setLeadFormData((prev) => ({
        //         ...prev,
        //         txtWhatsappNumberErr: ''
        //     }));
        // }

        if (
            !LeadFormData.txtEmail ||
            LeadFormData.txtEmail.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtEmailErr: 'Please Enter Email'
            }));
            return false;
        }
        else if (
            !emailRegex.test(
                LeadFormData.txtEmail.trim()
            )
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtEmailErr: 'Please Enter Valid Email'
            }));
            return false;
        }
        else {
            setLeadFormData((prev) => ({
                ...prev,
                txtEmailErr: ''
            }));
        }

        if (
            !LeadFormData.txtPermanentAddress ||
            LeadFormData.txtPermanentAddress.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtPermanentAddressErr:
                    'Please Enter Permanent Address'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtPermanentAddressErr: ''
            }));
        }

        if (
            !LeadFormData.txtCurrentAddress ||
            LeadFormData.txtCurrentAddress.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtCurrentAddressErr:
                    'Please Enter Current Address'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtCurrentAddressErr: ''
            }));
        }

        /* =========================
           EXPERIENCE & GERMAN
        ========================== */

        if (
            !LeadFormData.ddlExperience ||
            LeadFormData.ddlExperience.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                ddlExperienceErr:
                    'Please Enter Experience'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                ddlExperienceErr: ''
            }));
        }

        if (
            !LeadFormData.ddlStartedGerman ||
            LeadFormData.ddlStartedGerman.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                ddlStartedGermanErr:
                    'Please Select German Learning Status'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                ddlStartedGermanErr: ''
            }));
        }

        if (
            LeadFormData.ddlStartedGerman === 'Yes' &&
            (
                !LeadFormData.ddlGermanLevel ||
                LeadFormData.ddlGermanLevel.trim() === ''
            )
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                ddlGermanLevelErr:
                    'Please Select German Level'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                ddlGermanLevelErr: ''
            }));
        }

        /* =========================
           APPLICATION DETAILS
        ========================== */

        // Student Referred By Validation

        if (
            LeadFormData.txtStudentReferredBy === undefined ||
            LeadFormData.txtStudentReferredBy === null ||
            LeadFormData.txtStudentReferredBy.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                txtStudentReferredByErr: 'Please Select Student Referred By'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                txtStudentReferredByErr: ''
            }));
        }

        if (
            !LeadFormData.ddlApplicationStatus ||
            LeadFormData.ddlApplicationStatus.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                ddlApplicationStatusErr:
                    'Please Select Application Status'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                ddlApplicationStatusErr: ''
            }));
        }

        if (
            !LeadFormData.ddlEmployerType ||
            LeadFormData.ddlEmployerType.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                ddlEmployerTypeErr:
                    'Please Select Employer Type'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                ddlEmployerTypeErr: ''
            }));
        }

        /* =========================
           RECOGNITION & DEPLOYMENT
        ========================== */

        if (
            !LeadFormData.ddlAppliedRecognition ||
            LeadFormData.ddlAppliedRecognition.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                ddlAppliedRecognitionErr:
                    'Please Select Recognition Status'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                ddlAppliedRecognitionErr: ''
            }));
        }

        if (
            !LeadFormData.ddlRecognitionStatus ||
            LeadFormData.ddlRecognitionStatus.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                ddlRecognitionStatusErr:
                    'Please Select Recognition Status'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                ddlRecognitionStatusErr: ''
            }));
        }

        if (
            !LeadFormData.ddlDeploymentStatus ||
            LeadFormData.ddlDeploymentStatus.trim() === ''
        ) {
            setLeadFormData((prev) => ({
                ...prev,
                ddlDeploymentStatusErr:
                    'Please Select Deployment Status'
            }));
            return false;
        } else {
            setLeadFormData((prev) => ({
                ...prev,
                ddlDeploymentStatusErr: ''
            }));
        }

        /* =========================
           SAVE / UPDATE
        ========================== */

        console.log('STUDENT DATA => ', LeadFormData);

        if (mode === 'add') {
            setAddLead(true);
        } else {
            setEditLead(true);
        }
    };

    const ToggleDescriptionBox = () => {
        if (openDescriptionBox == true) {
            setOpenDescriptionBox(false);
        }
        else {
            setOpenDescriptionBox(true);
        }
    }

    const ToggleProjectDetailsBox = () => {
        if (openProjectDetailsBox == true) {
            setOpenProjectDetailsBox(false);
        }
        else {
            setOpenProjectDetailsBox(true);
        }
    }

    const AddDescription = () => {
        if (LeadFormData.txtLeadComment == undefined || LeadFormData.txtLeadComment == null || LeadFormData.txtLeadComment.trim() == '') {
            setLeadFormData((prev) => ({ ...prev, ['txtLeadCommentErr']: 'Please Enter Comment' }));
            return false;
        }
        else {
            setLeadFormData((prev) => ({ ...prev, ['txtLeadCommentErr']: '' }));
        }
        setUpdateLeadDesc(true);
    }



    const HandleAddNewLeadResponse = (res) => {
        setAddLead(false);
        if (res != false) {
            console.log(res.data.studentresponse.message.value);
            NavigateTo('institutes');
        }
        else {
            setShowAlert(true);
            setAlertType('error')
            setAlertMsg('Some Error Please Try Again');
        }
    }

    const NavigateTo = (route) => {
        navigate('/' + route, {});
    }

    const HandleGetLeadListSuccessResponse = (res) => {
        if (res != false && res != 'error') {

            setLeadDetails(res.data.studentlistresponse.rows);

            BindStudentDetails(res.data.studentlistresponse.rows[0]);
        }
        else {
            setLeadDetails([]);
        }
        setGetLeadDetails(false);
    }

    const BindStudentDetails = (studentData) => {
       
        setLeadFormData((prev) => ({
            ...prev,

            // PERSONAL INFORMATION
            txtFirstName: studentData.first_name || '',
            txtLastName: studentData.last_name || '',
            txtDOB: studentData.date_of_birth || '',
            txtAge: studentData.age || '',
            ddlQualification: studentData.qualification || '',

            ddlMaritalStatus: studentData.marital_status || '',
            txtKidsCount: studentData.kids_count || '',

            // CONTACT INFORMATION
            txtContactNumber: studentData.contact_number || '',
            txtWhatsappNumber: studentData.whatsapp_number || '',
            txtEmail: studentData.email || '',

            txtPermanentAddress:
                studentData.permanent_address || '',

            txtCurrentAddress:
                studentData.current_address || '',

            txtGuardianNumber:
                studentData.guardian_number || '',

            // EXPERIENCE & GERMAN DETAILS
            ddlExperience:
                studentData.total_experience || '',

            ddlStartedGerman:
                studentData.started_learning_german || '',

            ddlGermanLevel:
                studentData.german_level || '',

            // APPLICATION DETAILS
            txtUPRNPOC:
                studentData.uprn_poc || '',

            txtStudentReferredBy:
                studentData.student_referred_by || '',

            txtB2BPartnerName:
                studentData.b2b_partner_name || '',

            ddlApplicationStatus:
                studentData.application_status || '',

            txtGermanAgencyName:
                studentData.german_agency_name || '',

            txtEmployerName:
                studentData.employer_name || '',

            txtJobLocation:
                studentData.job_location || '',

            txtSalaryOffered:
                studentData.salary_offered || '',

            ddlEmployerType:
                studentData.employer_type || '',

            txtTentativeJoining:
                studentData.tentative_joining || '',

            ddlFinishingSchoolStatus:
                studentData.finishing_school_status || '',

            // DOCUMENTS
            chkBirthCertificate:
                studentData.birth_certificate || false,

            chkTenthMarksheet:
                studentData.tenth_marksheet || false,

            chkTwelfthMarksheet:
                studentData.twelfth_marksheet || false,

            chkNursingCertificate:
                studentData.nursing_certificate || false,

            chkTranscriptOfRecords:
                studentData.transcript_of_records || false,

            chkNursingMarksheetAllSemesters:
                studentData.nursing_marksheet_all_semesters || false,

            chkActiveNursingCouncilRegistration:
                studentData.active_nursing_council_registration || false,

            chkPassport:
                studentData.passport || false,

            chkProfessionalShotPhoto:
                studentData.professional_shot_photo || false,

            chkMarriageCertificate:
                studentData.marriage_certificate || false,

            chkGermanResume:
                studentData.german_resume || false,

            chkGoodStandingCertificate:
                studentData.good_standing_certificate || false,

            chkPoliceClearanceCertificate:
                studentData.police_clearance_certificate || false,

            chkVaccination:
                studentData.vaccination || false,

            chkB1GermanCertificate:
                studentData.b1_german_certificate || false,

            chkB2GermanCertificate:
                studentData.b2_german_certificate || false,

            chkExperienceLetter:
                studentData.experience_letter || false,

            // RECOGNITION & DEPLOYMENT
            ddlAppliedRecognition:
                studentData.applied_for_recognition_defizit_before || '',

            ddlRecognitionStatus:
                studentData.recognition_defizit_status || '',

            ddlDeploymentStatus:
                studentData.deployment_status || '',

            // NOTES
            txtNotes:
                studentData.notes || '',

            // CRM DETAILS
            ddlLeadStage:
                studentData.lead_stage || '',

            txtLeadSource:
                studentData.lead_source || '',

            ddlLeadOwner:
                studentData.lead_owner_name || '',

            ddlLeadDepartment:
                studentData.lead_owner_profile || '',

            txtLeadDesc:
                studentData.lead_description || '',

            // AUDIT DETAILS
            txtStudentAddedBy:
                studentData.student_added_by || '',

            txtStudentAddedOn:
                studentData.student_added_on || ''
        }));
    };

    const HandleCloseAlertMsg = (type) => {
        setTimeout(() => {
            setShowAlert(false);
            setAlertType('');
            setAlertMsg('');

        }, 3000)

    }

    const HandleUpdateLeadResponse = (res) => {
        //  console.log(res);

        if (res != false) {
            setGetLeadDetails(true);
            setShowAlert(true);
            setAlertType('success')
            setAlertMsg(res.data.studentupdateresponse.message.value);
        }
        else {
            setShowAlert(true);
            setAlertType('error')
            setAlertMsg('Please Try Again');
        }

        setLeadFormData((prev) => ({
            ...prev,
            txtInteractionDesc: ''
        }));


        setEditLead(false);
    }

    const HandleGetUsersListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let usersListData = res.data.userlistresponse.rows
            setUserListData(usersListData);
        }
        else {
            setUserListData([]);
        }
        setGetUserList(false);
    }

    const GetProjectDetails = () => {
        ToggleProjectDetailsBox();
    }

    const HandleUpdateLeadDescResponse = (res) => {
        if (mode == 'edit') {
            setGetLeadDetails(true);
        }
        setLeadFormData((prev) => ({ ...prev, ['txtLeadComment']: '' }));
        ToggleDescriptionBox();
        setUpdateLeadDesc(false);
    }

    const HandleGetInstituteListSuccessResponse = (res) => {
        setGetInstituteList(false);
        if (res !== false) {
            setInstituteListData(res.data.leadlistresponse.rows)
        }
        else {
            setInstituteListData([]);
        }
    }












    return (
        <Box>
            <StudentDetailsComp
                mystate={state}
                HandleInputs={HandleInputs}
                HandleCheckBox={HandleCheckBox}
                NavigateTo={NavigateTo}

                LeadFormData={LeadFormData}
                SaveOrUpdateLead={SaveOrUpdateLead}
                ToggleDescriptionBox={ToggleDescriptionBox}
                AddDescription={AddDescription}
                HandleCloseAlertMsg={HandleCloseAlertMsg}
                GetProjectDetails={GetProjectDetails}
                ToggleProjectDetailsBox={ToggleProjectDetailsBox}
            />
            {((getUserList === true) ? GetUserList(pnkstore, {}, userData.getState().token, HandleGetUsersListSuccessResponse) : "")}
            {((addLead === true) ? AddNewStudent(pnkstore, LeadFormData, userData.getState().token, HandleAddNewLeadResponse) : "")}
            {((editLead === true) ? UpdateStudent(pnkstore, LeadFormData, userData.getState().token, HandleUpdateLeadResponse) : "")}
            {((getInstituteList === true) ? GetAllInstitutes(pnkstore, {}, userData.getState().token, HandleGetInstituteListSuccessResponse) : "")}
            {((getLeadDetails === true) ? GetStudentList(pnkstore, leadSearchObj, userData.getState().token, HandleGetLeadListSuccessResponse) : "")}
            {((updateLeadDesc === true) ? UpdateStudentDesc(pnkstore, LeadFormData, userData.getState().token, HandleUpdateLeadDescResponse) : "")}
        </Box>
    )
}